<template>
  <div>
    <div class="controls-inner" v-bind:class="{'controls-open': multiPaneOpen, 'controls-closed': !multiPaneOpen}">
      <div @click="modesObj.multiPaneOpen = true" class="multi-pane-header bg-primary">
        <div class="container full-height">
            <div class="row full-height">
                <div class="col-8 v-center">
                   <h2 class="m-0">אפשרויות ניקוד</h2>
                </div>
                <div class="col-4 left-items">
                    <span v-show="multiPaneOpen" @click.stop="modesObj.multiPaneOpen = false"><i-times /></span>
                </div>
            </div>
        </div>
      </div>
      <div v-show="multiPaneOpen" class="full-height">
        <div class="pane-selectors-wrapper mt-1">
          <div class="pane-selector">
            <div @click="setActivePane('options')" class="pane-choice"
                                            v-bind:class="{'pane-selector-active': subPanesStatus.optionsOpen}">
              <span @click="showMorphBox = !showMorphBox" v-bind:class="[{ 'rounded-circle bg-secondary': showMorphBox}, 'd-inline-block morph-box-btn tool-btn'] ">
                <i class="fas fa-ellipsis-v" />
              </span>
              
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ניקוד אוטומטי
            </div>
          </div>
          <div class="pane-selector">
            <div @click="setActivePane('manual')" class="pane-choice"
                                            v-bind:class="{'pane-selector-active': subPanesStatus.manualOpen}">
              ניקוד ידני
            </div>
          </div>
        </div>
        <div v-show="showMorphBox" class="morph-box">
          <span @click.prevent="modesObj.showMorph = !(modesObj.showMorph)"><b-form-checkbox switch v-bind:checked="modesObj.showMorph">פרוט מורפולוגי</b-form-checkbox></span>
        </div>
        <div class="pane full-height" v-show="subPanesStatus.optionsOpen">
          <nikud-options-pane :sub-panes-status="subPanesStatus" :modes-obj="modesObj" />
        </div>
        <div class="pane pt-1 full-height" v-show="subPanesStatus.manualOpen">
          <manual-nikud-pane :sub-panes-status="subPanesStatus" :modes-obj="modesObj" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NikudOptionsPane from './NikudOptionsPane'
import ManualNikudPane from './ManualNikudPane'
import nikudMixins from '@/mixins/nikudMixins'
import $ from 'jquery'

export default {
  name: 'MobileOptionsMultiPane',
  components: {
    NikudOptionsPane,
    ManualNikudPane
  },
  props: ['modesObj'],
  mixins: [nikudMixins], // for modalOpen()
  data () {
    return {
      subPanesStatus: {
        optionsOpen: true,
        manualOpen: false
      },
      showMorphBox: false
    }
  },
  computed: {
    multiPaneOpen () {
      return this.modesObj.multiPaneOpen
    }
  },
  methods: {
    setActivePane (activePaneName) {
      ['options', 'manual'].forEach(paneName => {
        this.subPanesStatus[paneName + 'Open'] = paneName === activePaneName
      })
    }
  },
  mounted () {
    $(document).on('click', '.morph-box, .morph-box-btn', function (e) {
      e.stopPropagation() // note: only works b/c elements exist at this time!
    })
    $(document).on('click', () => {
      this.showMorphBox = false
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /* DocumentSettings-specific CSS goes here */
  .controls-inner {
    width: 100%;
    background-color: white;
    position: fixed;
    bottom: 0;
    z-index: 100;
    overflow: hidden;
  }
  .controls-open {
    height: 75%;
  }
  .controls-closed{
    height: 42px;
  }
  .multi-pane-header {
    color: white;
    height: 42px;
    margin-bottom: 5px;
    border-radius: 3px 3px 0 0;
    box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.3);
  }
  .v-center {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .left-items {
      display: flex;
      align-items: center;
      justify-content: flex-end;
  }
  .pane-title {
    background-color: #f6f6f6;
  }
  .item-list > li{
    position: relative;
    padding: 0 12px 5px 0;
  }
  .item-list p {
    margin-bottom: 0;
  }
  .item-list hr {
    margin-top: 2px;
    margin-bottom: 6px;
  }
  .item-list > li:after{
    position: absolute;
    right: 0;
    top: 0;
    content: "\F0D9";
    font-family: FontAwesome;
    color: #1b1b1b;
    font-size: 20px;
    line-height: 20px;
  }
  .second-checkboxes li {
    padding-right: 15px;
  }
  .notify-msg {
    position: fixed;
    left: 24px;
    bottom: 48px;
    width: 238px;
    height: 50px;
    padding: 15px 8px;
    text-align: center;
    border-radius: 3px;
    box-sizing: border-box;
    background-color: #494949;
    @media (max-width: 767px) {
      right: auto;
      left:10px;
      height: auto;
      padding: 12px 8px;
    }    
  }
  .notify-msg p{
    margin: 0;
    color: white;
  }
  .pane {
    // border-radius: 4px;
    // box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  }
  .pane:not(:last-child) {
    margin-bottom: 13px;
  }
  .pane-selectors-wrapper {
    display: block;
    border-top: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
  }
  .pane-selector {
    display: inline-block;
    width: 50%;
    cursor: pointer;
    text-align: center;
    padding: 0px;
    position: relative;
  }
  .pane-choice {
    padding: 8px;
    color: #c0c0c0;
  }
  .pane-selector-active {
    &::before{
      position: absolute;
      top:  0;
      left: 0;
      width: 100%;
      height: 3px;
      background: #007ee5;
      content: '';
    }
    color: black !important;
  }
  .morph-box-btn {
    height: 30px;
    width: 30px;
    right: 12px;
    padding-top: 3px;
    position: absolute;
    top: 6px;
  }
  .morph-box {
    position: absolute;
    width: 90%;
    right: 5%;
    height: 50px;
    border-radius: 2px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
    border: solid 1px #d8d8d8;
    padding: 10px 20px;
    z-index: 1;
    background-color: white;
  }
</style>
